import React from 'react'
import {theme} from 'antd'
import {Image} from 'antd'
import {ElementTemplatesType} from '../../../entities/elementType'
import {useIntl} from 'react-intl'

export type TemplatesGalleryProps = {
  templates: ElementTemplatesType
  setDraggableElement: (name: string) => void
  setCurrentElementName: (newName: string) => void
}

export function TemplatesGallery(props: TemplatesGalleryProps) {
  const {
    token: {colorPrimary},
  } = theme.useToken()
  const intl = useIntl()

  return (
    <div
      style={{
        color: colorPrimary,
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        maxHeight: '300px',
        overflow: 'hidden',
        overflowY: 'scroll',
      }}
    >
      {props.templates ? (
        Object.keys(props.templates).map((templateId, index) => {
          const template = props.templates[templateId]
          return (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                flexWrap: 'wrap',
                justifyContent: 'space-around',
              }}
              key={index}
            >
              <img
                onDragCapture={(e) => {
                  props.setDraggableElement(templateId)
                  props.setCurrentElementName(intl.formatMessage({id: `elementName-${templateId}`}))
                }}
                width={64} //{template.width}
                height={64} //{template.height}
                src={template.src}
              />
              <span
                style={{
                  textWrap: 'wrap',
                }}
              >
                {intl.formatMessage({id: `elementName-${templateId}`})}
              </span>
            </div>
          )
        })
      ) : (
        <div>{intl.formatMessage({id: 'noTemplatesForThisType'})}</div>
      )}
    </div>
  )
}
